import script from "./ApiTokensView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiTokensView.vue?vue&type=script&setup=true&lang=js"

import "./ApiTokensView.vue?vue&type=style&index=0&id=c64769c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c64769c8"]])

export default __exports__